import { PartialColorProps } from "../theme";
import { Avator } from "./Avator";
import { Check } from "./Check";
import { CircleFill } from "./CircleFill";
import { Edit } from "./Edit";
// Math
import { Minus } from "./Minus";
import { Plus } from "./Plus";
import { Time } from "./Time";
import { Triangle } from "./Triangle";
// Arrows
import { ArrowDown } from "./ArrowDown";
import { ArrowLeft } from "./ArrowLeft";
import { ArrowRight } from "./ArrowRight";
import { ArrowUp } from "./ArrowUp";
import { Question } from "./Question";
import { QuestionCircle } from "./QuestionCircle";
// Move
import { Close } from "./Close";

/**
 * @deprecated Use mui/icons-material
 */
export const Icon = {
  Check,
  CircleFill,
  Plus,
  Minus,
  Time,
  Edit,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Question,
  Avator,
  Close,
  QuestionCircle,
  Triangle,
};

export interface IconProps
  extends Omit<React.SVGAttributes<SVGSVGElement>, "color">, PartialColorProps {
  children?: never;
}
